import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "position-relative w-100 h-100 border border-5 border-white" }
const _hoisted_2 = { class: "position-absolute top-50 start-50 translate-middle" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "user_link"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "m-0 p-0"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "fs-small lh-sm" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/location-map-pin.png",
  width: "20",
  height: "20"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  key: 1,
  class: "ma-0 pa-0 text-nowrap"
}
const _hoisted_18 = { class: "row g-0 justify-content-center align-items-center fs-small lh-sm mt-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-10 col-xxl-auto border border-g03 bg-g03 text-white px-2 py-1 text-nowrap" }, " 更新者 ", -1)
const _hoisted_20 = { class: "col-10 col-xxl-auto border border-g03 bg-white px-2 py-1 text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelUnset = _resolveComponent("LabelUnset")!
  const _component_Action = _resolveComponent("Action")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", {
      class: _normalizeClass(["text-center align-middle text-nowrap p-0 h-100 px-0", _ctx.schedule.statusClass.typeClass]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectScheduleEdit(_ctx.schedule.routes.scheduleEdit)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: _ctx.schedule.routes.scheduleEdit
          }, _toDisplayString(_ctx.schedule.type.name), 9, _hoisted_3)
        ])
      ])
    ], 2),
    _createElementVNode("td", {
      class: "text-center align-middle a-deco text-nowrap user_cell px-0",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSheduleUserEditModal(_ctx.schedule.users, _ctx.schedule.id)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedule.users, (user, key) => {
        return (_openBlock(), _createElementBlock("span", { key: key }, [
          (key > 0 && key <= 1)
            ? (_openBlock(), _createElementBlock("br", _hoisted_4))
            : _createCommentVNode("", true),
          (user.id && key <= 1)
            ? (_openBlock(), _createElementBlock("a", _hoisted_5, _toDisplayString(user.displayName), 1))
            : _createCommentVNode("", true),
          (key == 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "..."))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.schedule.users.length == 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _createVNode(_component_LabelUnset)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", {
      class: "text-center align-middle px-0",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectScheduleEdit(_ctx.schedule.routes.scheduleEdit)))
    }, [
      (_ctx.schedule.strDate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.schedule.strDate), 1))
        : (_openBlock(), _createBlock(_component_LabelUnset, { key: 1 }))
    ]),
    _createElementVNode("td", {
      class: "align-middle a-deco",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectScheduleEdit(_ctx.schedule.routes.scheduleEdit)))
    }, [
      (_ctx.schedule.car && (_ctx.schedule.car.carNumber && _ctx.schedule.car.carModel.name))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.schedule.car.showRoute,
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.schedule.car.carNumber), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.schedule.car.carModel.name), 1)
          ], 8, _hoisted_9))
        : (_openBlock(), _createBlock(_component_LabelUnset, { key: 1 }))
    ]),
    _createElementVNode("td", {
      class: "text-center align-middle px-0",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirectScheduleEdit(_ctx.schedule.routes.scheduleEdit)))
    }, [
      (_ctx.schedule.cooperatingStoreName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.schedule.cooperatingStoreName), 1))
        : (_openBlock(), _createBlock(_component_LabelUnset, { key: 1 }))
    ]),
    _createElementVNode("td", {
      class: "text-center align-middle px-0",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.redirectScheduleEdit(_ctx.schedule.routes.scheduleEdit)))
    }, [
      (_ctx.schedule.deliveryAddress)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
            (_ctx.schedule.googleMapPosition)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: _ctx.schedule.googleMapPosition,
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, _hoisted_15, 8, _hoisted_13))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.schedule.deliveryAddress), 1)
          ]))
        : (_openBlock(), _createBlock(_component_LabelUnset, { key: 1 }))
    ]),
    _createElementVNode("td", {
      class: "text-center align-middle",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.redirectScheduleEdit(_ctx.schedule.routes.scheduleEdit)))
    }, [
      (_ctx.schedule.commentAbbreviation)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "ma-0 pa-0 text-nowrap",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "bottom",
            title: _ctx.schedule.comment
          }, _toDisplayString(_ctx.schedule.commentAbbreviation), 9, _hoisted_16))
        : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.schedule.comment), 1))
    ]),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("td", {
          key: 0,
          class: "text-center align-middle",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.redirectScheduleEdit(_ctx.schedule.routes.scheduleEdit)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.schedule.updatedAt) + " ", 1),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.schedule.createdUser.displayName), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Action, { schedule: _ctx.schedule }, null, 8, ["schedule"])
  ], 64))
}